import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const followUpRoutes: Routes = [
  {
    path: 'seguimiento',
    loadComponent: () =>
      import('./follow-up.component').then((c) => c.FollowUpComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'seguimiento-lead',
    loadComponent: () =>
      import('./pages/management/management.component').then(
        (c) => c.ManagementComponent
      ),
    canActivate: [AuthGuard],
  },
];
